import { ColData } from 'ufinet-web-components'

export const colsModule: ColData[] = [
	{ field: 'name', header: 'COL.MODULE.NAME', width: '250px', nonFilterable: true, editable: true },
	{ field: 'securityName', header: 'COL.APP.SECURITY_NAME', width: '250px', nonFilterable: true, editable: true },
	{ field: 'description', header: 'COL.MODULE.DESCRIPTION', width: '250px', nonFilterable: true, editable: true },
]
